<script setup>
import { Link } from '@inertiajs/vue3';
</script>

<template>
    <Link :href="'/'">
        <img src="/images/logo/logo_x2.svg" alt="Logo" />
    </Link>
</template>
